import { createFileRoute } from "@tanstack/react-router"

import { Connectors } from "@/pages/Connectors"

export const Route = createFileRoute("/connectors/")({
  component: Connectors,
})
